import { Carousel, type CarouselProps } from '../Carousel/Carousel';
import { ValidationCard, type ValidationCardProps } from './ValidationCard';

/** Horizontally scrollable row of ValidationCards with left/right navigation arrows. */
export type ValidationCardCarouselProps = Pick<
  CarouselProps,
  'className' | 'scrollIntoViewIndex' | 'scrollIntoViewNonce'
> & {
  items: ValidationCardProps[];
  /** Class applied to every ValidationCard in the track (e.g. to enforce a uniform width). */
  cardClassName?: string;
};

export function ValidationCardCarousel({ items, cardClassName, className = '', ...carouselProps }: ValidationCardCarouselProps) {
  const rootClasses = ['spark-validation-card-carousel', className].filter(Boolean).join(' ');
  return (
    <Carousel className={rootClasses} {...carouselProps}>
      {items.map((item, i) => (
        <ValidationCard key={i} {...item} className={[item.className, cardClassName].filter(Boolean).join(' ')} />
      ))}
    </Carousel>
  );
}
